import { render, staticRenderFns } from "./today-lotto-credit.vue?vue&type=template&id=2db9a2b9&"
import script from "./today-lotto-credit.vue?vue&type=script&lang=js&"
export * from "./today-lotto-credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports